import React from 'react'
import PropTypes from 'prop-types'
import { CardGroup } from 'components/Card'
import { IntegrationCard } from 'components/IntegrationCard'

export const EmbedIntegrationsSection = ({ selectedIntegration, onClick, embedIntegrations }) => {
  const maximumItemsPerRow = 5
  return (
    <div style={{ marginTop: '1rem' }}>
      <CardGroup itemsPerRow={maximumItemsPerRow}>
        {embedIntegrations.map((integration) => (
          <IntegrationCard
            key={integration.name}
            label={integration.label}
            image={integration.iconUrl}
            isSelected={selectedIntegration === integration.name}
            onClick={() => onClick(integration)}
          />
        ))}
      </CardGroup>
    </div>
  )
}

EmbedIntegrationsSection.propTypes = {
  selectedIntegration: PropTypes.string,
  onClick: PropTypes.func,
  embedIntegrations: PropTypes.arrayOf(PropTypes.object),
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EmbedIntegrationsSection/index.js